import { createContext } from 'react';

export const LoginTabPickedByUser = createContext(false);
